import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { ReconcilablePostingType } from '@modules-deprecated/bankReconciliation/types'

const colorMap: Record<ReconcilablePostingType, Color> = {
  bill: Color.Yellow400,
  billPayment: Color.Green400,
  daybookTransaction: Color.Green400,
  invoice: Color.Yellow400,
  invoicePayment: Color.Green400,
  salesTaxPayment: Color.Green400,
  salesTaxReturn: Color.Yellow400,
}

interface StatusIndicatorProps {
  color: ReconcilablePostingType
}

export const StatusIndicator = styled.span<StatusIndicatorProps>`
  width: 7px;
  height: 7px;
  margin: ${Spacing.S6};
  border-radius: 50%;
  background: ${({ color }) => colorMap[color] || Color.Yellow400};
`
